import React from 'react';
import { Form } from 'react-bootstrap';
import Button from '../UI/button';
import { useAddItinerary } from '../modals/itinerary/use-add-itinerary';

type AddItineraryFormProps = {
  label: string;
  placeholder?: string;
  submitTitle: string;
  onSuccess?: () => void;
};

const AddItineraryForm = ({
  label,
  placeholder,
  submitTitle,
  onSuccess
}: AddItineraryFormProps) => {
  const { itinerary, validated, handleInputChange, handleSubmit } =
    useAddItinerary(onSuccess);

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group>
        <Form.Label>{label}</Form.Label>
        <Form.Control
          type='text'
          placeholder={placeholder}
          value={itinerary.title}
          onChange={(e) => handleInputChange('title', e.target.value)}
          required
        />
      </Form.Group>
      <Form.Group className='mt-3'>
        <Form.Label>Description (optional)</Form.Label>
        <Form.Control
          as='textarea'
          rows={3}
          placeholder='Enter a description for your itinerary'
          value={itinerary.description || ''}
          onChange={(e) => handleInputChange('description', e.target.value)}
        />
      </Form.Group>
      <Button
        disabled={!validated}
        type='submit'
        width={167}
        className='mx-auto'
        style={{ marginTop: '24px' }}
      >
        {submitTitle}
      </Button>
    </Form>
  );
};

export default AddItineraryForm;
